import * as React from 'react';
import {
    Alert,
    Box,
    Button,
    Card,
    Collapse,
    IconButton,
    Stack,
    Typography,
} from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Persistent error list shown OUTSIDE the bulk-import dialog. Parent passes in
// `errors` (set after the dialog auto-closes); a Dismiss/Clear button resets.
export default function BulkErrorPanel({ errors, onDismiss }) {
    const visible = Array.isArray(errors) && errors.length > 0;
    return (
        <Collapse in={visible} unmountOnExit>
            <Card variant="outlined" sx={{ mt: 1, borderColor: '#c62828', bgcolor: '#fff5f5' }}>
                <Stack
                    direction="row"
                    alignItems="center"
                    spacing={1}
                    sx={{ px: 2, py: 1, borderBottom: '1px solid #f3d8d8', bgcolor: '#ffeaea' }}
                >
                    <ErrorOutlineIcon sx={{ color: '#c62828' }} />
                    <Typography variant="subtitle1" sx={{ flex: 1, fontWeight: 700, color: '#c62828' }}>
                        Import Errors ({(errors || []).length})
                    </Typography>
                    <Button
                        size="small"
                        startIcon={<ContentCopyIcon sx={{ fontSize: 14 }} />}
                        onClick={() => {
                            const txt = (errors || [])
                                .map((e) => `${e.imei}\t${e.reason}`)
                                .join('\n');
                            navigator.clipboard?.writeText(txt);
                        }}
                    >
                        Copy
                    </Button>
                    <IconButton size="small" onClick={onDismiss} aria-label="Dismiss errors">
                        <CloseIcon />
                    </IconButton>
                </Stack>
                <Box
                    sx={{
                        maxHeight: 240,
                        overflowY: 'auto',
                        p: 1.5,
                        fontFamily: 'monospace',
                        fontSize: 12,
                    }}
                >
                    {(errors || []).map((e, i) => (
                        <div key={i}>
                            <span style={{ color: '#999', display: 'inline-block', minWidth: 28 }}>
                                {i + 1}.
                            </span>
                            <span style={{ color: '#c62828', fontWeight: 600 }}>{e.imei}</span> — {e.reason}
                        </div>
                    ))}
                </Box>
                <Alert severity="info" sx={{ borderRadius: 0 }} icon={false}>
                    <Typography variant="caption">
                        Tip: fix the listed IMEIs and re-open "Multi IMEI / Excel Import" to retry.
                    </Typography>
                </Alert>
            </Card>
        </Collapse>
    );
}
